import { render } from "./CattleDashboard.vue?vue&type=template&id=6fe8097e"
import script from "./CattleDashboard.vue?vue&type=script&lang=js"
export * from "./CattleDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__